





import { Component, Vue, Emit } from "vue-property-decorator";
import { ServiceBase } from "@/service/base/ServiceBase";
import { Alert } from "@/components/Alert/Alert.ts";

@Component({
  components: {},
})
export default class Form extends Vue {
  protected dialog = false;
  protected dialogDelete = false;
  protected formTitle = "";
  protected formTitleCreate = "New Item";
  protected formTitleEdit = "Edit Item";
  protected editedIndex = "create"; // 'create', 'edit'
  protected editedItem: any = {};
  protected defaultItem: any = {};
  protected serviceBase = new ServiceBase();
  protected alert = new Alert();

  protected resetEditedItem() {
    this.$nextTick(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
    });
  }

  protected openCreateDialog() {
    this.resetEditedItem();
    this.editedIndex = "create";
    this.formTitle = this.formTitleCreate;
    this.dialog = true;
  }

  protected openEditDialog(item: any, getById = false, url = "") {
    this.editedIndex = "edit";
    this.formTitle = this.formTitleEdit;

    if (!getById) {
      // get editedItem from table
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    } else {
      // get editedItem from api call
      this.serviceBase
        .getById(item.id, url)
        .then((res: any) => {
          if (res.status === 200) {
            this.editedItem = res.data.data;
            this.dialog = true;
          } else {
            this.alert.popAlert("warning", `Warning: ${res.data.message}`, 3);
          }
        })
        .catch((error: any) => {
          this.alert.popAlert("error", `Error: ${error}}`, 3);
          console.log("error: ", error);
        });
    }
  }

  protected openDeleteDialog(item: any) {
    this.editedItem = Object.assign({}, item);
    this.dialogDelete = true;
  }

  protected closeDialog() {
    this.dialog = false;
    this.resetEditedItem();
  }

  protected closeDelete() {
    this.dialogDelete = false;
    this.resetEditedItem();
  }

  protected create(
    item: any,
    params: any = {},
    url = "",
    component: any = {
      getTableData: () => {
        return;
      },
    }
  ) {
    // create
    this.serviceBase
      .post(item, params, url)
      .then((res: any) => {
        if (res.status === 200) {
          if (res.data.message === "DATA_NOT_FOUND") {
            this.alert.popAlert("warning", `Warning: DATA_NOT_FOUND`, 3);
          }
          if (res.data.code === 200) {
            this.alert.popAlert("success", `${res.data.message}.`, 3);
          } else {
            this.alert.popAlert("warning", `Warning: ${res.data.message}`, 3);
          }
          this.editedItem = this.defaultItem;
          this.closeDialog();
          component.getTableData();
        } else {
          this.alert.popAlert("warning", `Warning: ${res.data.message}`, 3);
        }
      })
      .catch((error: any) => {
        this.alert.popAlert("error", `Error: ${error}}`, 3);
        console.log("error: ", error);
      });
  }

  protected save(
    item: any,
    params: any = {},
    url = "",
    component: any = {
      getTableData: () => {
        return;
      },
    }
  ) {
    // update
    this.serviceBase
      .put(item, params, url)
      .then((res: any) => {
        if (res.status === 200) {
          this.alert.popAlert("success", "Save success.", 3);
          this.editedItem = this.defaultItem;
          this.closeDialog();
          component.getTableData();
        } else {
          this.alert.popAlert("warning", `Warning: ${res.data.message}`, 3);
        }
      })
      .catch((error: any) => {
        this.alert.popAlert("error", `Error: ${error}}`, 3);
        console.log("error: ", error);
      });
  }

  protected deleteItemConfirm(
    id: number,
    params: any = {},
    url = "",
    component: any = {
      getTableData: () => {
        return;
      },
    }
  ) {
    // delete
    this.serviceBase
      .delete(id, params, url)
      .then((res: any) => {
        if (res.status === 200) {
          this.alert.popAlert("success", "Delete success.", 3);
          this.resetEditedItem();
          this.closeDelete();
          component.getTableData();
        } else {
          this.alert.popAlert("warning", `Warning: ${res.data.message}`, 3);
        }
      })
      .catch((error: any) => {
        this.alert.popAlert("error", `Error: ${error}}`, 3);
        console.log("error: ", error);
      });
  }
}
